export default async function GetEmployeeSummaryApi(positionId, perfCycleId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/performance/employee-summary?performanceCycle=${perfCycleId}&positionId=${positionId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => { res = response; })
      .catch((error) => { res = error; });
  } catch (error) {
    res = error;
  }
  return res;
}
